// Avatar sizes the row supports (core/Avatar scale). sm (32px) fits a 13px two-line row.
export const USER_OPTION_SIZE = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
};

export const USER_OPTION_SIZES = new Set(Object.values(USER_OPTION_SIZE));
